import type { KerningOverrides } from "./types";

export type KerningOverridesPreview = {
  overrides: KerningOverrides | null | undefined;
};

// Preview wins so per-keystroke writes replace (not merge with) the persisted
// value. Used by Textbox + Table2Cell render paths to pick the live overrides
// the wrap step should apply.
export const resolveKerningOverridesPreview = (
  preview: KerningOverridesPreview | null | undefined,
  persisted: KerningOverrides | null | undefined
): KerningOverrides | null | undefined =>
  preview ? preview.overrides : persisted;
